module.exports = __webpack_public_path__ + "static/media/cam.4c1a1734.png";